import { render, staticRenderFns } from "./Geospatial.vue?vue&type=template&id=35d3eaa1&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d3eaa1')) {
      api.createRecord('35d3eaa1', component.options)
    } else {
      api.reload('35d3eaa1', component.options)
    }
    module.hot.accept("./Geospatial.vue?vue&type=template&id=35d3eaa1&", function () {
      api.rerender('35d3eaa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/Geospatial.vue"
export default component.exports